"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useImages = () => {
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const [images, setImages] = (0, _react.useState)({
    _loading: true
  });
  (0, _react.useEffect)(() => {
    var _productDetailData$me;
    if ((0, _isEmpty.default)(productDetailData) || productDetailData !== null && productDetailData !== void 0 && productDetailData._loading) return;
    let _media = JSON.parse(JSON.stringify((_productDetailData$me = productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.mediaList) !== null && _productDetailData$me !== void 0 ? _productDetailData$me : []));
    setImages({
      entries: _media.length,
      items: _media
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(productDetailData)]);
  return images;
};
var _default = exports.default = useImages;